import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityPersonasAddFailure,
  entityPersonasAddRequest,
  entityPersonasAddSuccess,
  entityPersonasChangeFailure,
  entityPersonasChangeRequest,
  entityPersonasChangeRequestWithoutRedirection,
  entityPersonasChangeSuccess,
  entityPersonasChangeSuccessWithoutRedirection,
  entityPersonasLoadFailure,
  entityPersonasLoadRequest,
  entityPersonasLoadSuccess
} from './entity-personas.actions';

import { PersonasService } from './entity-personas.service';
import { authLoginSuccess } from '../../../core/auth/auth.actions';
import { NotificationService } from '../../../core/core.module';
import { entityPersonasFisicaAddSuccess } from '../../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { Update } from '@ngrx/entity';
import { Persona } from './entity-personas.model';
import { entityIntegranteAddSuccess } from '../../roles/entity-integrante/entity-integrante.actions';

@Injectable()
export class PersonasEffects {
  // load
  loadPreRequestPersonas = createEffect(() =>
    this.actions$.pipe(
      ofType(authLoginSuccess),
      map(() => entityPersonasLoadRequest())
    )
  );

  loadRequestPersonas = createEffect(() =>
    this.actions$.pipe(
      ofType(
        entityPersonasLoadRequest,
        entityPersonasFisicaAddSuccess,
        entityIntegranteAddSuccess
      ),
      mergeMap(() =>
        this.personasService.getPersonas().pipe(
          map((items) => entityPersonasLoadSuccess({ items })),
          catchError((error) => of(entityPersonasLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestPersona = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasAddRequest),
      switchMap((action) =>
        this.personasService.addPersona(action.item).pipe(
          map((item) => entityPersonasAddSuccess({ item })),
          catchError((error) => of(entityPersonasAddFailure({ error })))
        )
      )
    )
  );

  addSuccessPersona = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasAddSuccess),
        tap(() => {
          this.notificationService.success('Usuario registrado con éxito');
          return this.router.navigate(['/main', 'landing']);
        })
      ),
    { dispatch: false }
  );

  // change
  changeRequestPersona = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasChangeRequest),
      switchMap((action) =>
        this.personasService.changePersona(action.item).pipe(
          map((item: Persona) => {
            const itemUpdate: Update<Persona> = {
              id: item.id,
              changes: item
            };
            return entityPersonasChangeSuccess({ item: itemUpdate });
          }),
          catchError((error) => of(entityPersonasChangeFailure({ error })))
        )
      )
    )
  );

  changeRequestPersonaWithoutRedirection = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasChangeRequestWithoutRedirection),
      switchMap((action) =>
        this.personasService.changePersona(action.item).pipe(
          map((item: Persona) => {
            const itemUpdate: Update<Persona> = {
              id: item.id,
              changes: item
            };
            return entityPersonasChangeSuccessWithoutRedirection({ item: itemUpdate });
          }),
          catchError((error) => of(entityPersonasChangeFailure({ error })))
        )
      )
    )
  );

  changeSuccessPersona = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasChangeSuccess),
        tap(() => {
          this.notificationService.success('Usuario modificado con éxito');
          return this.router.navigate(['/main', 'landing']);
        })
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private personasService: PersonasService,
    private router: Router,
    private readonly notificationService: NotificationService
  ) {
    this.personasService.url = environment.apiUrl;
  }
}
